export const DEVICE_FEATURE_VERSIONS = {
  gateway: {
    AIR_HANDLER_UNIT_ROOM_ASSOCIATION: "5.112.0",
    BOILERROOM_BACNET_DEVICE_ID: "5.103.0",
    CONTROLLERS: "5.132.0",
    COV_SENSOR_PARAM: "5.92.0",
    SOUND_SENSOR_PARAM: "5.77.0",
    TEMPERATURE_CORRECTION_COEF: "5.76.0",
  },
  valve: {
    BOILERROOM_AUTO_HEATING_CURVE: "4.53.0",
    COV_SENSOR_PARAM: "4.80.0",
    MANUAL_BALANCING: "4.52.0",
    MODE_RF: "4.50.0",
    SOUND_SENSOR_PARAM: "4.76.0",
    TEMPERATURE_CORRECTION_COEF: "4.73.0",
    TRIG_CUR: "4.105.0",
  },
  borderRouter: {
    MODE_RF: "4.44.0",
  },
} as const;
